import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import AppTitle from '../../../layouts/AppTitle';
import { useDispatch } from 'react-redux';
import { submitForm } from '../../../../store/actions/AuthActions';

const ContactUs = () => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({});

  const handleChange = e => {
    setValues({ ...values, [e?.target?.name]: e?.target?.value });
  };

  const handleSubmit = e => {
    e.preventDefault();
    dispatch(submitForm('contactForm', '', values));
    setValues({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div>
      <Helmet>
        <title>Contact SayCheeze Cakes – Custom Cake Orders & Enquiries</title>
        <meta
          name='description'
          content='Get in touch with SayCheeze Cakes in Bangalore for custom cake orders, bulk enquiries, and special occasion desserts. Call, email, or send us a message.'
        />
        <link rel='canonical' href='https://www.saycheezecakes.com/contact' />
      </Helmet>

      <AppTitle title={'Contact Us'} from={'Home'} to='Contact' link='/' />

      <div className='section-padding-03 contact-section2 contact-section2_bg'>
        <div className='container custom-container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='contact-section2_content'>
                <h2 className='contact-section2__title'>Information</h2>
                <p className='contact-section2__text'>
                  Feel free to contact us using the details below for any inquiries or assistance.
                </p>
                <ul className='contact-section2_list'>
                  <li>
                    <span className='contact-section2_list__icon'>
                      <i className='lastudioicon lastudioicon-pin-3-2'></i>
                    </span>
                    <span className='contact-section2_list__text'>
                      Address:
                      <br />
                      Bangalore, Karnataka, India
                    </span>
                  </li>
                  <li>
                    <span className='contact-section2_list__icon'>
                      <i className='lastudioicon lastudioicon-phone-2'></i>
                    </span>
                    <span className='contact-section2_list__text'>
                      Mobile: <br />
                      +91 99454 23080
                    </span>
                  </li>
                  <li>
                    <span className='contact-section2_list__icon'>
                      <i className='lastudioicon lastudioicon-mail'></i>
                    </span>
                    <span className='contact-section2_list__text'>
                      Email: <br /> saycheezecakes@gmail.com
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='contact-section2_formbg'>
                <h2 className='contact-section2_form__title'>Say Something...</h2>
                <form className='contact-section2_form' id='contact-form' onSubmit={handleSubmit}>
                  <div className='row'>
                    <div className='col-sm-6 col-6 form-p'>
                      <div className='form-group'>
                        <label>Name*</label>
                        <input
                          className='form-field'
                          required
                          onChange={handleChange}
                          type='text'
                          value={values?.name}
                          name='name'
                        />
                      </div>
                    </div>
                    <div className='col-sm-6 col-6 form-p'>
                      <div className='form-group'>
                        <label>Phone Number*</label>
                        <input
                          className='form-field'
                          type='text'
                          name='phone'
                          required
                          value={values?.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className='col-md-12 form-p'>
                      <div className='form-group'>
                        <label>Email Address*</label>
                        <input
                          className='form-field'
                          type='email'
                          name='email'
                          required
                          onChange={handleChange}
                          value={values?.email}
                        />
                      </div>
                    </div>
                    <div className='col-md-12 form-p'>
                      <div className='form-group'>
                        <label>Message</label>
                        <textarea
                          className='form-control text-area'
                          name='message'
                          value={values?.message}
                          onChange={handleChange}
                        ></textarea>
                      </div>
                    </div>
                    <div className='col-md-12 form-p'>
                      <div className='form-group mb-0 d-flex justify-content-center'>
                        <button
                          className='btn btn-secondary btn-hover-primary'
                          type='submit'
                          value='Send Massage'
                        >
                          Send Message
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                <div className='form-messege'></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
